import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileTextInput: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiTextInput_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiTextInputRole',
      bindings: [
        {
          title: 'mobui_MobuiTextInput_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [FieldType.text, FieldType.email],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'mobui_MobuiTextInput_dataBinding_placeholder_label',
          prop: 'placeholder',
          supportedFieldTypes: [FieldType.text, FieldType.email],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
